import { createContext, useContext, useEffect, useState } from "react";

interface PageContextValue {
  content: string;
  setContent: (content: string) => void;
}

const PageContext = createContext<PageContextValue | undefined>(undefined);

export function PageContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [content, setContent] = useState("");

  return (
    <PageContext.Provider value={{ content, setContent }}>
      {children}
    </PageContext.Provider>
  );
}

export function usePageContext() {
  const context = useContext(PageContext);

  if (!context) {
    throw new Error("usePageContext must be used within a PageContextProvider");
  }

  return context;
}

export function useSetPageContext(data: unknown) {
  const { setContent } = usePageContext();

  useEffect(() => {
    if (data) {
      try {
        setContent(typeof data === "string" ? data : JSON.stringify(data));
      } catch {
        setContent("");
      }
    } else {
      setContent("");
    }

    return () => setContent("");
  }, [data, setContent]);
}

